module.exports = __webpack_public_path__ + "static/media/roxLogo.6a3fa1fc.jpg";